<template>
    <!-- <div>
        <v-btn class="test ma-10" to="/home" color="transparent white--text"><v-icon left x-large class="orange--text">add_circle</v-icon><span color="transparent" class="transparent hidden-sm-and-down">New Search</span></v-btn>
    </div> -->
    <!-- <v-btn
              absolute
              small
              dark
              fab
              bottom
              right
              open-on-hover
              color="orange"  
            >
              <v-icon @click="hitTheSpot()">search</v-icon>
            </v-btn> -->

    <div class="float">
        
    </div>
    
</template>

<script>
// import Results from '@/views/Results.vue';
    export default {
        data() {
            return {

            }
        },
        methods: {
            hitTheSpot(){

            }
        },
    }
</script>

<style scoped>
.test{
    bottom: 0;
    right: 0;
    position: fixed;
}
</style>